module.exports = __webpack_public_path__ + "img/feather.0323f615.svg";